<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4633 9.94518L1.49585 0H11.0254C16.7576 0 21.468 4.36489 22.0001 9.94518H11.4633Z" fill="#F06269"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4633 12.0549H22.0001C21.468 17.6352 16.7576 22.0001 11.0254 22.0001H1.49585L11.4633 12.0549Z" fill="#FFDA1A"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5296 11L0 1.4917V20.5082L9.5296 11Z" fill="#6F4FCC"/>
    </svg>
</template>